<template>
  <nav class="nav-extended" style="margin-bottom: 1rem">
    <div class="nav-wrapper">
      <a href="/" class="brand-logo left">  <i class="material-icons large">home</i> SOLTAR <small>{{ $route.name }}</small></a>

      <ul id="nav-mobile " class="right">
        <li>
          <a class="mdi mdi-chevron-left" @click="$router.back()">ATRÁS</a>
        </li>
      </ul>
    </div>
  </nav>
  <div style="padding-top: 1rem" class="container">
    <div class="">
      <div class="">
        <form @submit="submit" id="form-produccon-terminada">
          <div class="row">
            <div class="col s12 input-field">
              <label class="active" for="event_status">Estatus</label>
              <input type="text" name="event_status" id="event_status" v-model="event_status" disabled required
                list="event_status_list" />
              <datalist id="event_status_list">
                <option>Producción terminada</option>
                <option>Trabajo con proveedor para acabado</option>
              </datalist>
            </div>
          </div>
          <!--  Action button  -->
          <div class="fixed-action-btn">
            <button v-if="!cargando" type="submit" class="btn-floating btn-large blue">
              <i class="large material-icons">save</i>
            </button>
            <div v-else class="preloader-wrapper active">
              <div class="spinner-layer spinner-red-only">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div>
                <div class="gap-patch">
                  <div class="circle"></div>
                </div>
                <div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </div>
          <!--  /Action button  -->
        </form>
        <QRScaner @cartons="
          (val) => {
            cartons = val;
          }
        " @limpiar_cartons="
          () => {
            cartons = {};
          }
        " :db="db" :cartons="cartons"></QRScaner>
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";
import firebase from "firebase/app";
import QRScaner from "../../submodules/qr-carton-escaner";
import { EVENT_CARTON_PRODUCCION_TERMINADA, ENV } from "@/constants";
import helpers from "../../../../../helpers";
import { updateCartons } from "@/tracker/firebase_models/updateCartons"
export default {
  components: { QRScaner },
  beforeCreate() {
    firebase.auth().onAuthStateChanged((user) => {
      this.user = user;
      helpers.checkClaims(user);
    });
  },
  created() { },

  data() {
    var db = firebase.firestore();

    let shipvias = JSON.parse(window.localStorage.getItem("shipvias"));
    return {
      db: db,

      cargando: false,
      user: {},
      shipvias: shipvias,
      cartons: {},
      event_status: "Producción terminada",
      shipvia: "5008\tTaller Cafetal",
      almacen: "",
      production_completed: {},
    };
  },
  computed: {
    completed_jobs_with_parts() {
      let production_completed = { ...this.production_completed };
      Object.keys(production_completed).forEach((ccmasterid) => {
        let parts_delivered = Object.keys(production_completed[ccmasterid]).filter((part) => production_completed[ccmasterid][part]);
        production_completed[ccmasterid] = parts_delivered;
        if (!parts_delivered.length) {
          delete production_completed[ccmasterid];
        }
      })
      return production_completed;
    },
    jobs_in_cartons() {
      let cartons = Object.values(this.cartons),
        ccmasterids = {};
      cartons.forEach((carton) => {
        if (!ccmasterids[carton.ccmasterid])
          ccmasterids[carton.ccmasterid] = {};
        ccmasterids[carton.ccmasterid][carton.jobpart] = true;
      });
      // Object.keys(ccmasterids).forEach((key) => {
      //   ccmasterids[key] = Object.keys(ccmasterids[key]);
      // });
      return ccmasterids;
    },
    evento() {
      let desc = `Capturado por ${window.user.displayName} en ${this.shipvia}.`;
      return helpers.createCartonEvent(
        this.event_status,
        desc,
        window.user.email
      );
    },
  },
  methods: {
    submit($e) {
      $e.preventDefault();
      this.save();
    },
    logout() {
      firebase.auth().signOut();
    },
    change_status_jobpart_produccion_terminada(ccmasterids_jobparts, idToken) {
      if (!Object.keys(ccmasterids_jobparts).length) return Promise.resolve();
      return fetch(
        `${ENV.VUE_APP_SOLTAR_API_URL}/job/batch/production_finished_parts/queue`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + idToken,
          },
          body: JSON.stringify(ccmasterids_jobparts),
        },
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + idToken,
          },
          body: JSON.stringify(ccmasterids_jobparts),
        },
      );
    },
    async save() {
      let batch = {}, // Definimos un lote de registros
        user = this.user,
        cartons = this.cartons,
        cartons_keys = Object.keys(cartons);

      if (!cartons_keys.length)
        return M.toast({
          html: "No hay ningún paquete en la lista",
          classes: "red",
        });

      cartons_keys.forEach((cartonId) => {
        // Por cada carton
        let carton_data = cartons[cartonId];
        //docRef = Carton.docRef(cartonId, this.db); // Referencia a un documento
        // Agrega información al documento

        carton_data.terminado = "SERVER_TIMESTAMP";
        carton_data.status = this.evento.status;
        carton_data.status_desc = this.evento.desc;
        carton_data.status_code = EVENT_CARTON_PRODUCCION_TERMINADA;

        // Agrega evento
        let event_data = { ...this.evento, status_code: carton_data.status_code }
        carton_data["ARRAY_UNION.eventos"] = event_data;

        carton_data.location = this.shipvia;
        carton_data.descargado = null;
        carton_data.cargado = null;
        // en caso de ser tarima no puede ir qtythiscarton en null
        carton_data.qtythiscarton = carton_data.qtythiscarton || 0;
        // informacion sobre usuario
        carton_data.last_user_email = user.email;
        // timestamps
        carton_data.updated_at = "SERVER_TIMESTAMP";
        carton_data.updated = (new Date()).toLocaleString();
        // Sino existe el documento se crea con la información, si existe se actualiza.
        batch[cartonId] = carton_data;
        //resplado en base de datos mongo
        //Carton.backupDoc({ _id: cartonId, ...carton_data });
      });
      this.cargando = true;
      const idToken = await window.user.getIdToken();
      updateCartons(batch, idToken)
        .then(async() => {
          console.log("Status de partes actualizado");
          //despachar evento para limpiar tablas
          document.dispatchEvent(new Event("limpiarEscaneos"));
          this.cartons = {};
          fetch(ENV.VUE_APP_N8N_TALLER_WEBHOOK_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": idToken,
            },
            body: JSON.stringify(batch),
          });
          //Todo correcto
          M.toast({ html: "Guardado exitosamente", classes: "green" });
        })
        .catch((err) => {
          M.toast({ html: "Error: " + err, classes: "red" });
        })
        .finally(() => {
          this.cargando = false;
        });
  

    },
  },
  watch: {
    jobs_in_cartons(newVal) {
      let production_completed = { ...newVal };
      this.production_completed = production_completed;
    },
  }
};
</script>
